import { create } from "zustand";

interface EmailVerificationState {
  /**
   * Email awaiting OTP verification. Set when a login attempt lands on an
   * unverified account, and read by the verify-email page so it knows whose
   * code to check. Held in memory only (no `persist`) — it clears on refresh.
   */
  pendingEmail: string;
  setPendingEmail: (email: string) => void;
}

/**
 * Tracks the email awaiting OTP verification between the login screen (which
 * sets it when the backend reports an unverified account) and the verify-email
 * step (which reads it). Lives in memory only — not persisted — because it
 * carries a PII email address.
 */
export const useEmailVerificationStore = create<EmailVerificationState>()((set) => ({
  pendingEmail: "",
  setPendingEmail: (pendingEmail) => set({ pendingEmail }),
}));
